import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RightLinks extends Component {
  render() {
    const { s, data, handleClickQuestion } = this.props;
    return (
      <div className={s.rightLinks}>
        <div style={{ flex: 1 }}>
          <div className={s.title}>防控知识</div>
          <div className={s.fkBox}>
            <img
              className={s.jc}
              src="/assets/images/icon/cd-tfxq/jc.png"
              alt=""
            />
            <div className={s.fkMsgBox}>
              <div className={s.fkList}>
                <div>
                  <a
                    className="a1"
                    href="http://www.chengdu.gov.cn/chengdu/c135628/2020-05/11/content_90af195babb54396878889608a8241e6.shtml"
                    target="_blank"
                  >
                    办公场所和公共场所空调能开吗？ 权威解答来了
                  </a>
                </div>
                <div>
                  <a
                    className="a2"
                    href="http://www.chengdu.gov.cn/chengdu/c135628/2020-05/10/content_3b2c90cc7a984474999b8270c642a793.shtml"
                    target="_blank"
                  >
                    核酸检测与抗体检测各自有什么用途？
                  </a>
                </div>
                <div>
                  <a
                    className="a3"
                    href="http://www.chengdu.gov.cn/chengdu/c135628/2020-05/09/content_6017d2030d124a1c833c4cf0ac5cb54f.shtml"
                    target="_blank"
                  >
                    国家卫健委：低风险地区校园内学生不需佩戴口罩
                    老师授课时不需戴口罩
                  </a>
                </div>
                <div>
                  <a
                    className="a4"
                    href="http://www.chengdu.gov.cn/chengdu/c135628/2020-05/09/content_d9c31666f5194a4e8b0558c5c360c229.shtml"
                    target="_blank"
                  >
                    热浪来袭可以使用空调吗？
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={s.divider} />
          <div className={s.title}>热点问题</div>
          <div className={s.docTip}>
            <ol>
              {data.map(({ title }) => (
                <li key={title} onClick={() => handleClickQuestion(title)}>
                  {title}
                </li>
              ))}
            </ol>
          </div>
          <div className={s.divider} />
          <div className={s.title}>热点办事</div>
          <div className={s.links}>
            <div>
              <a
                href="https://etax.sichuan.chinatax.gov.cn/nfzx-web/index.html?&amp;id=10000&amp;_=1571908297594#/taxpayerSchool"
                target="_blank"
                className={s.b0}
              >
                <img src="/assets/images/icon/cd-tfxq/bs1.png" alt="" />
                <div>纳税学堂</div>
              </a>
            </div>
            <div>
              <a
                className={s.b1}
                href="http://www.sczwfw.gov.cn/app/sclegalservice/theme?areaCode=510110000000&amp;code=106"
                target="_blank"
              >
                <img src="/assets/images/icon/cd-tfxq/bs2.png" alt="" />
                <div>社会保障</div>
              </a>
            </div>
            <div>
              <a
                className={s.b2}
                target="_blank"
                href="http://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin"
              >
                <img src="/assets/images/icon/cd-tfxq/bs3.png" alt="" />
                <div>
                  企业名称
                  <br />
                  自主申报
                </div>
              </a>
            </div>
            <div>
              <a
                className={s.b3}
                target="_blank"
                href="https://sc.122.gov.cn/m/login?"
              >
                <img src="/assets/images/icon/cd-tfxq/bs4.png" alt="" />
                <div>
                  行驶证、驾驶
                  <br />
                  证补换
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RightLinks.propTypes = {
  s: PropTypes.shape().isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};
